import React from 'react';
import {useTheme} from '../../../theme';
import {BaseDragableLayout} from './BaseDragableLayout';
import {mapToBaseProperties} from '../functions';
import {DragableItem, DragableLayoutProps} from '../types';

export const DragableLayout = function <TItem extends DragableItem>(
  props: React.PropsWithChildren<DragableLayoutProps<TItem>>,
) {
  const {
    type,
    item,
    enabled,
    onBeginDrag,
    onEndDrag,
    onPress,
    children,
    ...rest
  } = props;
  const theme = useTheme();

  const baseProps = mapToBaseProperties(theme, rest);

  return (
    <BaseDragableLayout
      type={type}
      enabled={enabled}
      item={item}
      onPress={onPress}
      onBeginDrag={onBeginDrag}
      onEndDrag={onEndDrag}
      {...baseProps}>
      {children}
    </BaseDragableLayout>
  );
};
